<template>
  <div>
    <div class="overlay" @click="$emit('close')"></div>
    <div class="modal_fixed">
      <div class="popup_box op_down modal_cont" id="">
        <img :src="closeIconSrc" class="btn_close" @click="$emit('close')">
        <h1>{{ getTranslations.home_modals_confirm_purchase_purchase }}</h1>
        <img :src="prizeSpinSrc" class="op_down_img">
        <p><b>{{ getBundleData.numberOfCoins ? getBundleData.numberOfCoins + ' ' + getTranslations.home_modals_confirm_purchase_games :''}}
          {{getBundleData.numberOfCoins && getBundleData.points ? getTranslations.home_modals_confirm_purchase_successfull_and :''}}
          {{ getBundleData.points ? getBundleData.points + ' ' + getTranslations.home_store_points : '' }}
          – {{ getBundleData.price}} {{ getBundleData.currencyCode }}</b></p>
        <p>{{ getTranslations.home_modals_confirm_purchase_via_sms_playing_more }}</p>
        <p>{{ getTranslations.home_modals_confirm_purchase_via_sms_purchase_now_by }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters } from 'vuex';
import SkinMixin from '@/common/mixins/skin';

export default {
  name: 'confirmPurchaseViaSms',
  mixins: [SkinMixin],
  computed: {
    closeIconSrc() {
      return this.$_skinImage({ fileName: 'store/icon-close-back-popup.svg', skins: [100] });
    },
    prizeSpinSrc() {
      return this.$_skinImage({ fileName: 'popups/prize-spin.svg', skins: [100] });
    },
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getBundleData',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/store/ConfirmPurchaseViaSms.vue